import _ from "lodash";

export const isEven = (number) => number % 2 === 0;
export const epgLinkByLinkWeek = (number) => number % 3 === 0;

const DESPATCH_IMPC_PERFORMANCE = (columns, data) => {
  const reportData = data;

  const dynamicColumns = _.map(
    columns.slice(2).filter((column) => column.show !== false)
  );
  reportData.weekHeaders = _.map(dynamicColumns, (column) => column.Header);

  reportData.rows = _.map(data.rows, (dataRow) => ({
    ...dataRow,
    dynamicFields: _.map(dynamicColumns, (column) => {
      const columnId = column.id.replace(/\./g, "-");
      const value = dataRow[columnId];

      if (column.type === "number") {
        return !value ? 0 : value;
      }

      return value;
    }),
  }));

  return reportData;
};

const CARDIT_BY_RECEIVING_AIRLINE = (columns, data) => {
  const reportData = data;
  const dynamicColumns = _.filter(
    columns,
    (column) => column.parentColumn.metadataForDownload
  );
  if (dynamicColumns.length) {
    reportData.firstLine = _.map(
      dynamicColumns,
      (column) => column.parentColumn.metadataForDownload.firstLine
    );
    reportData.secondLine = _.map(
      dynamicColumns,
      (column) => column.parentColumn.metadataForDownload.secondLine
    );
    reportData.rows = _.map(data.rows, (dataRow) => ({
      ...dataRow,
      dynamicFields: _.map(dynamicColumns, (column) => dataRow[column.id]),
    }));
  }
  return reportData;
};

const CARDIT_BY_SENDING_POST = (columns, data) => {
  const reportData = data;
  const dynamicColumns = _.filter(
    columns,
    (column) => column.parentColumn.metadataForDownload
  );
  if (dynamicColumns.length) {
    reportData.firstLine = _.map(
      dynamicColumns,
      (column) => column.parentColumn.metadataForDownload.firstLine
    );
    reportData.secondLine = _.map(
      dynamicColumns,
      (column) => column.parentColumn.metadataForDownload.secondLine
    );
    reportData.rows = _.map(data.rows, (dataRow) => ({
      ...dataRow,
      dynamicFields: _.map(dynamicColumns, (column) => dataRow[column.id]),
    }));
  }
  return reportData;
};

const RESDES_MANAGEMENT_SUMMARY_EPG = (columns, data) => {
  const reportData = data;
  const dynamicColumns = _.filter(
    columns,
    (column) => column.parentColumn.metadataForDownload
  );
  if (dynamicColumns.length) {
    reportData.firstLine = _.map(
      dynamicColumns,
      (column) => column.parentColumn.metadataForDownload.firstLine
    );
    reportData.rows = _.map(data.rows, (dataRow) => ({
      ...dataRow,
      dynamicFields: _.map(dynamicColumns, (column) => dataRow[column.id]),
      // eslint-disable-next-line no-restricted-globals
      performance: isNaN(parseFloat(dataRow.performance))
        ? dataRow.performance
        : parseFloat(dataRow.performance),
    }));
  }
  return reportData;
};

const EPG_LINK_BY_LINK_REPORT_013 = (columns, data) => {
  const reportData = data;
  const dynamicColumns = _.filter(
    columns,
    (column) => column.parentColumn.metadataForDownload
  );
  if (dynamicColumns.length) {
    reportData.headers = _.map(dynamicColumns, "Header");
    reportData.weeks = _.map(dynamicColumns, (column, index) =>
      epgLinkByLinkWeek(index)
        ? column.parentColumn.metadataForDownload.week
        : ""
    );
    reportData.dates = _.map(dynamicColumns, (column, index) =>
      epgLinkByLinkWeek(index)
        ? column.parentColumn.metadataForDownload.date
        : ""
    );
    reportData.rows = _.map(data.rows, (dataRow) => ({
      ...dataRow,
      dynamicFields: _.map(dynamicColumns, (column) => dataRow[column.id]),
    }));
  }
  return reportData;
};

const PREDES_V21_OVERVIEW = (columns, data) => {
  const reportData = data;
  const dynamicColumns = _.filter(
    columns,
    (column) => column.parentColumn.metadataForDownload
  );
  if (dynamicColumns.length) {
    reportData.firstLine = _.map(
      dynamicColumns,
      (column) => column.parentColumn.metadataForDownload.firstLine
    );
    reportData.rows = _.map(data.rows, (dataRow) => ({
      ...dataRow,
      dynamicFields: _.map(dynamicColumns, (column) => dataRow[column.id]),
    }));
  }
  return reportData;
};

export default {
  IMPC_TO_IMPC_DESPATCH_PERFORMANCE: DESPATCH_IMPC_PERFORMANCE,
  POST_TO_POST_DESPATCH_PERFORMANCE: DESPATCH_IMPC_PERFORMANCE,
  CARDIT_BY_RECEIVING_AIRLINE,
  CARDIT_BY_RECEIVING_AIRLINE_NUMBERED: CARDIT_BY_RECEIVING_AIRLINE,
  CARDIT_BY_SENDING_POST,
  CARDIT_BY_SENDING_POST_NUMBERED: CARDIT_BY_SENDING_POST,
  RESDIT_BY_RECEIVING_POST: CARDIT_BY_SENDING_POST,
  RESDIT_BY_RECEIVING_POST_NUMBERED: CARDIT_BY_SENDING_POST,
  RESDIT_BY_SENDING_AIRLINE: CARDIT_BY_RECEIVING_AIRLINE,
  RESDIT_BY_SENDING_AIRLINE_NUMBERED: CARDIT_BY_RECEIVING_AIRLINE,
  RESDES_MANAGEMENT_SUMMARY_EPG,
  EPG_LINK_BY_LINK_REPORT_013,
  EDI_EXCHANGE_LETTER_706: PREDES_V21_OVERVIEW,
  EDI_EXCHANGE_PARCEL_706: PREDES_V21_OVERVIEW,
  EDI_EXCHANGE_EMS_706: PREDES_V21_OVERVIEW,
};
